<template>
  <svg id="uitroepteken" viewBox="0 0 64 64">
    <svg>
      <path
        d="M32.5,63.8C15.1,63.8,1,49.7,1,32.3C1,14.9,15.1,0.8,32.5,0.8C49.9,0.8,64,14.9,64,32.3C64,49.7,49.9,63.8,32.5,63.8z
      M32.5,4.1C16.9,4.1,4.3,16.7,4.3,32.3c0,15.6,12.7,28.2,28.2,28.2s28.2-12.7,28.2-28.2C60.7,16.7,48.1,4.1,32.5,4.1z"
      />
    </svg>
    <svg>
      <path
        d="M29.5,42.6c0-0.8,0.3-1.6,0.9-2.1c0.5-0.5,1.3-0.9,2.1-0.9s1.6,0.3,2.1,0.9c0.5,0.5,0.9,1.3,0.9,2.1s-0.3,1.6-0.9,2.1
                    c-0.5,0.5-1.3,0.9-2.1,0.9s-1.6-0.3-2.1-0.9C29.8,44.2,29.5,43.4,29.5,42.6z M30.5,36.7c-0.1-0.8-0.2-2.5-0.3-4.5
                    c-0.1-2-0.2-4.3-0.2-6.6c-0.1-2.2-0.1-4.4-0.1-5.9h5.4c0,1.6,0,3.7-0.1,5.9c-0.1,2.3-0.1,4.6-0.2,6.6s-0.2,3.7-0.3,4.5H30.5z"
      />
    </svg>
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IconUitroepteken extends Vue {}
</script>
